import type * as React from "react"
import { cn } from "@/lib/utils"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"

export function SiteHeader({
  title = "Dashboard",
  breadcrumb,
}: {
  title?: string
  breadcrumb?: React.ReactNode
}) {
  return (
    <header
      className={cn(
        "flex shrink-0 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)",
        breadcrumb
          ? "min-h-(--header-height) flex-col justify-center"
          : "h-(--header-height) items-center",
      )}
    >
      <div
        className={cn(
          "flex w-full gap-1 px-4 lg:gap-2 lg:px-6",
          breadcrumb ? "flex-col gap-2 py-2.5" : "items-center",
        )}
      >
        {breadcrumb ? <div className="min-w-0 w-full">{breadcrumb}</div> : null}
        <div className="flex min-h-9 items-center gap-1 lg:gap-2">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mx-2 h-4 data-vertical:self-auto" />
          <h1 className="min-w-0 text-base font-semibold tracking-tight lg:text-lg">{title}</h1>
        </div>
      </div>
    </header>
  )
}
